/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2026-05-08 17:31:40
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-05-08 17:33:19
 * @FilePath: /designcenter/src/constant/siteMapping.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/** 站点标识符类型 */
export type SiteIdentifier =
  | 'cn'
  | 'hk'
  | 'tw'
  | 'mo'
  | 'de'
  | 'de-en'
  | 'jp'
  | 'ja'
  | 'kr'
  | 'es'
  | 'ru'
  | 'en'
  | 'au'
  | 'sg'
  | 'uk'
  | 'fr'
  | 'it'
  | 'nl'
  | 'mx'

/** 语言代码类型 */
export type LanguageCode =
  | 'zh-CN'
  | 'zh-HK'
  | 'zh-TW'
  | 'de'
  | 'en'
  | 'ja'
  | 'ko'
  | 'es'
  | 'ru-RU'
  | 'en-GB'
  | 'fr'
  | 'it'
  | 'nl'

/** 站点到语言代码的映射 */
export const SITE_LANGUAGE_MAP: Record<SiteIdentifier, LanguageCode> = {
  cn: 'zh-CN',
  hk: 'zh-HK',
  tw: 'zh-TW',
  mo: 'zh-HK',
  de: 'de',
  'de-en': 'en',
  jp: 'ja',
  ja: 'ja',
  kr: 'ko',
  es: 'es',
  ru: 'ru-RU',
  en: 'en',
  au: 'en',
  sg: 'en',
  uk: 'en-GB',
  fr: 'fr',
  it: 'it',
  nl: 'nl',
  mx: 'es',
}

/** 默认站点 */
export const DEFAULT_SITE: SiteIdentifier = 'en'

/** 根据站点获取语言代码，未知站点回退到 'en' */
export function getLanguageCode(site: string): LanguageCode {
  return SITE_LANGUAGE_MAP[site as SiteIdentifier] ?? 'en'
}

/** 判断是否为有效站点标识符 */
export function isValidSite(site: string): site is SiteIdentifier {
  return site in SITE_LANGUAGE_MAP
}
